<template>
    <div class="recommend-books" v-loading="loading">
        <ul class="cate-nav">
            <li
                v-for="(item, index) in categories"
                :key="item.order || index"
                class="cate-item"
                :class="{ active: activeKey === (item.order || String(index)) }"
                @click="changeCategory(item, index)"
            >
                {{ item.facetName }}
            </li>
        </ul>

        <div class="recommend-panel">
            <h3 class="panel-tit">好书推荐</h3>
            <ul v-if="bookList.length" class="book-grid">
                <li
                    v-for="(item, index) in bookList"
                    :key="item.id || index"
                    class="book-item"
                    @click="toBook(item)"
                >
                    <div class="cover">
                        <img :src="item.coverPath" :alt="item.bookName" />
                    </div>
                    <p class="name" v-html="item.bookName"></p>
                    <p class="author" :title="item.author">{{ item.author }}（{{ item.dynasty?item.dynasty:'' }}）</p>
                </li>
            </ul>
            <p v-else class="empty">暂无推荐书目</p>
        </div>
    </div>
</template>

<script>
import { bookClassificationList } from '../../../io/api.js';

export default {
    name: 'RecommendBooks',
    data() {
        return {
            loading: false,
            categories: [],
            activeKey: '',
            bookList: [],
        };
    },
    mounted() {
        this.getList();
    },
    methods: {
        getList() {
            this.loading = true;
            bookClassificationList()
                .then((res) => {
                    const { code, data, msg } = res.data || {};
                    if (code === 0) {
                        const list = Array.isArray(data) ? data : [];
                        this.categories = list;
                        if (list.length) {
                            this.changeCategory(list[0], 0);
                        } else {
                            this.bookList = [];
                        }
                    } else {
                        this.categories = [];
                        this.bookList = [];
                        this.$message.error(msg || '书目加载失败～');
                    }
                })
                .catch(() => {
                    this.categories = [];
                    this.bookList = [];
                    this.$message.error('书目加载失败～');
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        changeCategory(item, index) {
            const key = item.order != null ? String(item.order) : String(index);
            this.activeKey = key;
            this.bookList = item.bookList || [];
        },
        toBook(item) {
            this.$router.push({
                path: '/bookCatalogue',
                query: { id: item.id },
            });
        },
    },
};
</script>

<style lang="less" scoped>
.recommend-books {
    width: 1200px;
    margin: 0 auto 40px;
}

.cate-nav {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around; 
    margin-bottom: 24px;
}

.cate-item {
    min-width: 108px;
    height: 36px;
    line-height: 34px;
    padding: 0 16px;
    text-align: center;
    border: 1px solid #386DE8;
    background: #F1F5FE;
    color: #386DE8;
    font-size: 14px;
    cursor: pointer;
    box-sizing: border-box;
    transition: all 0.2s ease;
    border-radius: 6px;

    &:hover,
    &.active {
        border-color: #386DE8;
        color: #fff;
        background: #386DE8;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    }
}

.recommend-panel {
    background: #F7F7F7;
    padding: 20px 24px 28px;
    border-radius: 6px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
}

.panel-tit {
    margin: 0 0 16px;
    padding-bottom: 12px;
    font-size: 24px;
    font-weight: bold;
    color: #222;
    line-height: 36px;
    border-bottom: 1px solid #DCDFE6;
}

.book-grid {
    display: grid;
    grid-template-columns: repeat(5, minmax(0, 1fr));
    gap: 28px 20px;
}

.book-item {
    text-align: center;
    cursor: pointer;

    &:hover {
        .name {
            color: #386DE8;
        }
    }
}

.cover {
    width: 140px;
    height: 190px;
    margin: 0 auto 12px;
    background: #fff;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);

    img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        display: block;
    }
}

.name {
    margin: 0 0 6px;
    font-size: 14px;
    font-weight: bold;
    color: #222;
    line-height: 22px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.author {
    margin: 0 0 4px;
    font-size: 13px;
    color: #888;
    line-height: 18px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.meta {
    margin: 0;
    font-size: 13px;
    color: #999;
    line-height: 20px;
}

.empty {
    margin: 0;
    text-align: center;
    color: #999;
    font-size: 16px;
    line-height: 160px;
}
</style>
